import { render } from "./MemberTier.vue?vue&type=template&id=1b9f0a17&scoped=true"
import script from "./MemberTier.vue?vue&type=script&lang=js"
export * from "./MemberTier.vue?vue&type=script&lang=js"

import "./MemberTier.vue?vue&type=style&index=0&id=1b9f0a17&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9f0a17"]])

export default __exports__